/**
 * LocalStorage cache for the "Bulk Sort" panel.
 *
 * Two things are cached:
 *   - The configured parent folder ID (e.g. the Drive ID of "01. Kimono")
 *   - The enumerated list of target-category subfolders
 *
 * The target list is cached indefinitely but the panel also exposes a
 * refresh button which calls `clearSortTargets` before re-listing.
 */

const PARENT_KEY = "kra_sort_parent_id";
const TARGETS_KEY = "kra_sort_targets_v1";

export interface SortTarget {
  id: string;
  name: string;
  /** Airtable kimono_tag resolved by the server's KIMONO_TAG_MAP. Null if
   *  the folder name didn't match any pattern — admin can still pick this
   *  target, the record is just created without a kimono_tag. */
  suggestedTag: string | null;
}

export function getSortParent(): string | null {
  return localStorage.getItem(PARENT_KEY);
}

export function setSortParent(folderId: string): void {
  localStorage.setItem(PARENT_KEY, folderId);
}

export function clearSortParent(): void {
  localStorage.removeItem(PARENT_KEY);
  clearSortTargets();
}

export function getSortTargets(): SortTarget[] | null {
  try {
    const raw = localStorage.getItem(TARGETS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SortTarget[];
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
  } catch {
    return null;
  }
}

export function setSortTargets(targets: SortTarget[]): void {
  localStorage.setItem(TARGETS_KEY, JSON.stringify(targets));
}

export function clearSortTargets(): void {
  localStorage.removeItem(TARGETS_KEY);
}
